/* TelaPersonalizzata Configuratore Ex-Zakeke V8
 * Editor client-side + varianti Shopify + upload file + carrello.
 */
(() => {
  'use strict';

  const VERSION = '8.0.0';
  const photoRules = window.TPImageCompatibility;
  if (!photoRules) throw new Error('Modulo condiviso regole foto non caricato.');
  const DPI = photoRules.RULES.outputDpi;
  const MAX_FILE_BYTES = photoRules.RULES.maxFileBytes;
  const MAX_SOURCE_PIXELS = photoRules.RULES.maxSourcePixels;
  const HISTORY_LIMIT = 30;
  const FONT_GROUPS = [
    { label: 'Classici', fonts: ['Arial', 'Georgia', 'Verdana', 'Trebuchet MS', 'Courier New'] },
    { label: 'Moderni', fonts: ['Roboto', 'Montserrat', 'Poppins', 'Open Sans', 'Lato', 'Bebas Neue'] },
    { label: 'Eleganti', fonts: ['Playfair Display', 'Merriweather', 'Cinzel'] },
    { label: 'Scritti a mano', fonts: ['Pacifico', 'Dancing Script', 'Great Vibes', 'Lobster', 'Caveat', 'Sacramento'] }
  ];
  const FONT_STYLESHEET_URL = 'https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Caveat:wght@400;700&family=Cinzel:wght@400;700&family=Dancing+Script:wght@400;700&family=Great+Vibes&family=Inter:wght@400;600;700;800&family=Lato:wght@400;700&family=Lobster&family=Merriweather:wght@400;700&family=Montserrat:wght@400;600;700&family=Open+Sans:wght@400;600;700&family=Pacifico&family=Playfair+Display:wght@400;700&family=Poppins:wght@400;600;700&family=Roboto:wght@400;500;700&family=Sacramento&display=swap';
  const SYSTEM_FONTS = new Set(['Arial', 'Georgia', 'Verdana', 'Trebuchet MS', 'Courier New']);
  let fontPickerBuilt = false;
  let fontStylesPromise = null;
  let dragRenderFrame = 0;
  const COLOR_MAP = {
    bianca: '#ffffff', bianco: '#ffffff', arancione: '#ef8f23', azzurra: '#78b8df', azzurro: '#78b8df',
    blu: '#29588f', blue: '#29588f', gialla: '#edca42', giallo: '#edca42', nera: '#17191b', nero: '#17191b',
    rosa: '#e991aa', rossa: '#bc3c3c', rosso: '#bc3c3c', verde: '#488d62', grigio: '#96989b'
  };

  const root = document.getElementById('tp-v8-app');
  if (!root) return;
  const $ = (id) => document.getElementById(id);
  const canvas = $('tpv8-canvas');
  const ctx = canvas.getContext('2d', { alpha: true });

  function demoData() {
    const variant = (id, title, price, options, image = null) => ({ id, title, price, available: true, options, featured_image: image ? { src: image } : null });
    const image = 'https://cdn.shopify.com/s/files/1/0689/4344/6292/files/Tazza-personalizzata-con-foto.webp?v=1744822418';
    const colors = ['Bianca', 'Arancione', 'Azzurra', 'Blu', 'Gialla', 'Nera', 'Rosa', 'Rossa', 'Verde'];
    const shirtColors = ['Bianco', 'Rosso', 'Verde', 'Blue', 'Giallo', 'Grigio', 'Nero'];
    const sizes = ['S', 'M', 'L', 'XL', 'XXL'];
    return {
      mode: 'demo', shop: '', currency: 'EUR', moneyFormat: '€ {{amount_with_comma_separator}}', storage: {},
      products: [
        { key: 'mug', label: 'Tazza personalizzata', spec: { wCm: 20, hCm: 9.7, safeX: .05, safeY: .08, printBackground: 'transparent' }, product: { id: 1, title: 'Stampa foto su tazza', handle: 'stampa-foto-su-tazza', options: ['Color'], featured_image: image, variants: colors.map((c, i) => variant(100 + i, c, 990, [c])) } },
        { key: 'magic-mug', label: 'Tazza magica', spec: { wCm: 20, hCm: 9.7, safeX: .05, safeY: .08, printBackground: 'transparent' }, product: { id: 2, title: 'Stampa foto su tazza magica', handle: 'stampa-foto-su-tazza-magica', options: ['Title'], featured_image: 'https://cdn.shopify.com/s/files/1/0689/4344/6292/files/Tazza-magica-personalizzata.webp?v=1751880960', variants: [variant(200, 'Default Title', 1690, ['Default Title'])] } },
        { key: 'cushion', label: 'Cuscino con foto', spec: { wCm: 36, hCm: 36, safeX: .04, safeY: .04, printBackground: 'transparent' }, product: { id: 3, title: 'Stampa foto su cuscino', handle: 'stampa-foto-su-cuscino', options: ['Color'], featured_image: 'https://cdn.shopify.com/s/files/1/0689/4344/6292/files/stampa-foto-su-cuscino.webp?v=1747657133', variants: ['Bianco', 'Arancione', 'Azzurro', 'Blue', 'Giallo', 'Nero', 'Rosa', 'Rosso'].map((c, i) => variant(300 + i, c, 1890, [c])) } },
        { key: 'puzzle', label: 'Puzzle con foto', spec: { wCm: 20, hCm: 28.5, safeX: .035, safeY: .035, printBackground: 'white', variantRules: { '44357486739732': { wCm: 20, hCm: 28.5, detail: '91 pezzi', label: 'Piccolo · 20 × 28,5 cm · 91 pezzi' }, '44357486772500': { wCm: 28.5, hCm: 40, detail: '181 pezzi', label: 'Grande · 28,5 × 40 cm · 181 pezzi' } }, sizeRules: { '21 X 29 CM': { wCm: 20, hCm: 28.5, detail: '91 pezzi' }, '29 X 42 CM': { wCm: 28.5, hCm: 40, detail: '181 pezzi' } } }, product: { id: 4, title: 'Stampa foto su puzzle', handle: 'stampa-foto-su-puzzle', options: ['Size'], featured_image: 'https://cdn.shopify.com/s/files/1/0689/4344/6292/files/Stampa_foto_puzzle_personalizzato.webp?v=1747657054', variants: [variant(400, '21 X 29 CM', 1090, ['21 X 29 CM']), variant(401, '29 X 42 CM', 1800, ['29 X 42 CM'])] } },
        { key: 'tshirt', label: 'T-shirt personalizzata', spec: { wCm: 25, hCm: 35, safeX: .05, safeY: .05, printBackground: 'transparent' }, product: { id: 5, title: 'T-shirt con stampa personalizzata', handle: 't-shirt-con-stampa-personalizzata', options: ['Color', 'Taglia'], featured_image: 'https://cdn.shopify.com/s/files/1/0689/4344/6292/files/Magliette_con_foto_stampata.webp?v=1747657841', variants: shirtColors.flatMap((c, ci) => sizes.map((s, si) => variant(500 + ci * 10 + si, `${c} / ${s}`, 2000, [c, s]))) } },
        { key: 'mousepad', label: 'Tappetino mouse', spec: { wCm: 23, hCm: 19, safeX: .035, safeY: .035, printBackground: 'white' }, product: { id: 6, title: 'Stampa foto su tappetino mouse', handle: 'stampa-foto-su-tappetino-mouse', options: ['Title'], featured_image: 'https://cdn.shopify.com/s/files/1/0689/4344/6292/files/Tappetino_mouse_con_foto_personalizzato.webp?v=1747657486', variants: [variant(600, 'Default Title', 1400, ['Default Title'])] } }
      ]
    };
  }

  function readConfig() {
    const node = $('tp-v8-config-data');
    if (!node) return demoData();
    try {
      const parsed = JSON.parse(node.textContent);
      parsed.products = (parsed.products || []).filter((item) => item && item.product && item.product.id);
      return parsed.products.length ? parsed : demoData();
    } catch (error) {
      console.error('TP V8 configurazione non valida', error);
      return demoData();
    }
  }

  const config = readConfig();
  const state = {
    productKey: '', selections: {}, variant: null, spec: null, productColor: '#ffffff', elements: [], selectedId: null,
    dragging: null, history: [], future: [], dirty: false, busy: false, grid: false
  };

  const outputDpi = () => state.productKey === 'cushion' ? 200 : DPI;
  const cmToPx = (cm, dpi = DPI) => Math.round((Number(cm) / 2.54) * dpi);
  const uid = () => (globalThis.crypto && crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`);
  const productEntry = () => config.products.find((item) => item.key === state.productKey) || config.products[0];
  const product = () => productEntry().product;
  const optionNames = () => (product().options || []).map((value) => typeof value === 'string' ? value : value.name).filter((name) => name && name !== 'Title');
  const normalize = (value) => String(value || '').trim().toLocaleLowerCase('it-IT');
  const escapeHtml = (value) => String(value || '').replace(/[&<>'"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' }[c]));
  const safeFilename = (value) => String(value || 'file').normalize('NFKD').replace(/[^a-zA-Z0-9._-]+/g, '-').replace(/-+/g, '-').slice(0, 90);

  function variantOptions(variant) {
    if (Array.isArray(variant.options)) return variant.options;
    return optionNames().map((_, index) => variant[`option${index + 1}`] || '');
  }

  function availableVariants() {
    return (product().variants || []).filter((variant) => variant.available !== false);
  }

  function findVariant() {
    const names = optionNames();
    const variants = availableVariants();
    if (!names.length) return variants[0] || (product().variants || [])[0] || null;
    return variants.find((variant) => {
      const values = variantOptions(variant);
      return names.every((name, index) => normalize(values[index]) === normalize(state.selections[name]));
    }) || variants[0] || null;
  }

  function currentSpec(referenceImage = state.elements.find((item) => item.type === 'image')) {
    const base = { ...productEntry().spec };
    const variantRule = base.variantRules && state.variant ? base.variantRules[String(state.variant.id)] : null;
    if (variantRule) {
      Object.assign(base, variantRule);
    } else if (base.sizeRules && state.variant) {
      const sizeIndex = optionNames().findIndex((name) => /size|misura|formato/i.test(name));
      const sizeValue = sizeIndex >= 0 ? variantOptions(state.variant)[sizeIndex] : state.variant.title;
      if (base.sizeRules[sizeValue]) Object.assign(base, base.sizeRules[sizeValue]);
    }
    // Only the puzzle follows the first photo; print/export use this same spec.
    if (state.productKey === 'puzzle' && referenceImage && referenceImage.naturalW > referenceImage.naturalH) {
      const shortSide = Math.min(base.wCm, base.hCm);
      base.wCm = Math.max(base.wCm, base.hCm);
      base.hCm = shortSide;
    }
    return base;
  }

  function syncPuzzleOrientation(preserve = true) {
    if (state.productKey !== 'puzzle' || !state.spec) return;
    const nextSpec = currentSpec();
    if (nextSpec.wCm === state.spec.wCm && nextSpec.hCm === state.spec.hCm) return;
    state.spec = nextSpec;
    resizeCanvas(preserve);
    updateVariant(true);
  }

  function money(cents) {
    const amount = Number(cents || 0) / 100;
    try { return new Intl.NumberFormat('it-IT', { style: 'currency', currency: config.currency || 'EUR' }).format(amount); }
    catch (_) { return `${amount.toFixed(2).replace('.', ',')} €`; }
  }

  function variantPriceMarkup(variant) {
    if (!variant) return 'Non disponibile';
    const price = Number(variant.price || 0);
    const compareAt = Number(variant.compare_at_price || 0);
    if (state.productKey === 'puzzle' || !(compareAt > price)) return money(price);
    const percentage = Math.round((1 - price / compareAt) * 100);
    return `<span class="tpv8-live-price"><s aria-label="Prezzo precedente">${money(compareAt)}</s><b>-${percentage}%</b><em>${money(price)}</em></span>`;
  }

  function featuredImage() {
    const source = state.variant && state.variant.featured_image ? state.variant.featured_image : product().featured_image;
    if (!source) return '';
    return typeof source === 'string' ? source : (source.src || source.url || '');
  }

  function isTshirt() { return state.productKey === 'tshirt'; }

  function syncTshirtPreview() {
    const stage = root.querySelector('.tpv8-canvas-stage');
    const label = root.querySelector('.tpv8-canvas-label');
    if (!stage || !label) return;
    root.classList.toggle('tpv8-tshirt-preview', isTshirt());
    if (!isTshirt()) {
      stage.style.removeProperty('background-image');
      label.textContent = 'Area stampabile reale';
      return;
    }
    const initialVariantId = root.dataset.tpv8InitialVariantId || '';
    if (!root.dataset.tpv8InitialPreviewApplied && initialVariantId && state.variant && String(state.variant.id) === initialVariantId) {
      root.dataset.tpv8InitialPreviewApplied = 'true';
      label.textContent = 'Anteprima indicativa · Area massima 25 × 35 cm';
      return;
    }
    const source = featuredImage();
    stage.style.backgroundImage = source ? `url("${source.replace(/"/g, '\\"')}")` : 'none';
    label.textContent = 'Anteprima indicativa · Area massima 25 × 35 cm';
  }

  function cloneElements() {
    return state.elements.map((item) => ({ ...item }));
  }

  function remember() {
    state.history.push(cloneElements());
    if (state.history.length > HISTORY_LIMIT) state.history.shift();
    state.future = [];
    state.dirty = true;
    updateUndoButtons();
  }

  function undo() {
    if (!state.history.length) return;
    state.future.push(cloneElements());
    state.elements = state.history.pop();
    state.selectedId = null;
    renderAll(false);
    updateUndoButtons();
  }

  function redo() {
    if (!state.future.length) return;
    state.history.push(cloneElements());
    state.elements = state.future.pop();
    state.selectedId = null;
    renderAll(false);
    updateUndoButtons();
  }

  function updateUndoButtons() {
    $('tpv8-undo').disabled = !state.history.length || state.busy;
    $('tpv8-redo').disabled = !state.future.length || state.busy;
  }

  function showContinuousPanel() {
    root.querySelectorAll('[data-tpv8-panel]').forEach((panel) => {
      panel.hidden = false;
      panel.classList.remove('is-active');
    });
    scheduleShellFit();
  }

  let fitFrame = 0;
  function scheduleShellFit() {
    cancelAnimationFrame(fitFrame);
    fitFrame = requestAnimationFrame(fitShell);
  }

  function fitShell() {
    const desktop = matchMedia('(min-width: 861px)').matches;
    const printArea = $('tpv8-print-area');
    root.classList.toggle('tpv8-shell-fit', desktop);
    if (!desktop) {
      root.style.removeProperty('--tpv8-shell-height');
      printArea.style.removeProperty('width');
      printArea.style.removeProperty('height');
      return;
    }
    const viewportHeight = Math.round((globalThis.visualViewport && visualViewport.height) || innerHeight);
    const top = Math.max(0, Math.round(root.getBoundingClientRect().top));
    const hasExtraTools = root.classList.contains('tpv8-has-image') || root.classList.contains('tpv8-has-text');
    const minimumHeight = hasExtraTools ? 600 : 560;
    const maximumHeight = hasExtraTools ? 650 : 620;
    const availableHeight = viewportHeight - top - 28;
    const shellHeight = Math.max(minimumHeight, Math.min(maximumHeight, availableHeight));
    root.style.setProperty('--tpv8-shell-height', `${shellHeight}px`);
    requestAnimationFrame(() => {
      const stage = root.querySelector('.tpv8-canvas-stage');
      if (!stage || !state.spec) return;
      const rect = stage.getBoundingClientRect();
      const style = getComputedStyle(stage);
      const availableW = Math.max(120, rect.width - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight));
      const availableH = Math.max(120, rect.height - parseFloat(style.paddingTop) - parseFloat(style.paddingBottom));
      const ratio = state.spec.wCm / state.spec.hCm;
      const width = Math.max(120, Math.min(1040, availableW, availableH * ratio));
      printArea.style.width = `${Math.floor(width)}px`;
      printArea.style.height = `${Math.floor(width / ratio)}px`;
    });
  }

  function populateProductSelect() {
    const select = $('tpv8-product');
    select.innerHTML = '';
    config.products.forEach((entry) => {
      const option = document.createElement('option');
      option.value = entry.key;
      option.textContent = entry.label || entry.product.title;
      select.appendChild(option);
    });
    const query = new URLSearchParams(location.search);
    const requested = query.get('product') || query.get('handle') || '';
    const match = config.products.find((entry) => entry.key === requested || entry.product.handle === requested);
    selectProduct(match ? match.key : config.products[0].key, true);
  }

  function initialSelections(entry) {
    const names = (entry.product.options || []).map((value) => typeof value === 'string' ? value : value.name).filter((name) => name && name !== 'Title');
    const first = (entry.product.variants || []).find((variant) => variant.available !== false) || entry.product.variants[0];
    const values = first ? variantOptions(first) : [];
    const query = new URLSearchParams(location.search);
    const selections = {};
    names.forEach((name, index) => {
      const queryValue = query.get(name.toLowerCase()) || query.get(name) || '';
      const allowed = [...new Set((entry.product.variants || []).map((variant) => variantOptions(variant)[index]))];
      selections[name] = allowed.find((value) => normalize(value) === normalize(queryValue)) || values[index] || allowed[0] || '';
    });
    return selections;
  }

  function selectProduct(key, force = false) {
    if (!force && state.elements.length && !confirm('Cambiando prodotto perderai la personalizzazione attuale. Continuare?')) {
      $('tpv8-product').value = state.productKey;
      return;
    }
    releaseImageUrls();
    state.productKey = key;
    state.selections = initialSelections(productEntry());
    state.variant = findVariant();
    state.spec = currentSpec();
    state.elements = [];
    state.selectedId = null;
    state.history = [];
    state.future = [];
    state.dirty = false;
    $('tpv8-product').value = key;
    const flow = root.querySelector('.tpv8-panel-flow');
    if (flow) flow.scrollTop = 0;
    renderVariantControls();
    updateVariant(true);
    renderAll();
  }

  function optionValues(index) {
    return [...new Set((product().variants || []).filter((variant) => variant.available !== false).map((variant) => variantOptions(variant)[index]).filter(Boolean))];
  }

  function colorForName(name) {
    return COLOR_MAP[normalize(name)] || '#d6d7d7';
  }

  function optionLabel(name) {
    if (state.productKey === 'puzzle' && /^size$/i.test(name)) return 'Formato';
    if (!/color/i.test(name)) return name;
    if (state.productKey === 'mug') return 'Colore manico e interno';
    if (state.productKey === 'cushion') return 'Colore del retro';
    if (state.productKey === 'tshirt') return 'Colore della maglietta';
    return 'Colore';
  }
  function optionDisplayValue(value, index) {
    const rules = productEntry().spec && productEntry().spec.variantRules;
    if (!rules) return value;
    const matchedVariant = (product().variants || []).find((variant) => normalize(variantOptions(variant)[index]) === normalize(value));
    const rule = matchedVariant ? rules[String(matchedVariant.id)] : null;
    return rule && rule.label ? rule.label : value;
  }

  function renderVariantControls() {
    const box = $('tpv8-variant-controls');
    box.innerHTML = '';
    const names = optionNames();
    if (!names.length) {
      box.innerHTML = '<p class="tpv8-muted">Questo prodotto non richiede altre opzioni.</p>';
      return;
    }
    names.forEach((name, index) => {
      const field = document.createElement('div');
      field.className = 'tpv8-field';
      const label = document.createElement('label');
      const id = `tpv8-option-${index}`;
      label.htmlFor = id;
      label.textContent = optionLabel(name);
      const select = document.createElement('select');
      select.id = id;
      select.dataset.optionName = name;
      optionValues(index).forEach((value) => {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = optionDisplayValue(value, index);
        select.appendChild(option);
      });
      select.value = state.selections[name];
      select.addEventListener('change', () => changeOption(name, select.value));
      field.append(label, select);
      if (/color/i.test(name)) field.appendChild(buildColorSwatches(name, index));
      box.appendChild(field);
    });
  }

  function buildColorSwatches(name, index) {
    const box = document.createElement('div');
    box.className = 'tpv8-swatches';
    box.setAttribute('aria-label', 'Colori disponibili');
    optionValues(index).forEach((value) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = `tpv8-swatch${normalize(value) === normalize(state.selections[name]) ? ' is-active' : ''}`;
      button.style.setProperty('--swatch', colorForName(value));
      button.dataset.value = value;
      button.setAttribute('aria-label', value);
      button.setAttribute('aria-pressed', normalize(value) === normalize(state.selections[name]) ? 'true' : 'false');
      button.title = value;
      button.addEventListener('click', () => changeOption(name, value));
      box.appendChild(button);
    });
    return box;
  }

  function changeOption(name, value) {
    state.selections[name] = value;
    state.variant = findVariant();
    const oldSpec = state.spec || currentSpec();
    state.spec = currentSpec();
    const ratioChanged = Math.abs((oldSpec.wCm / oldSpec.hCm) - (state.spec.wCm / state.spec.hCm)) > .001;
    resizeCanvas(ratioChanged);
    renderVariantControls();
    updateVariant(false);
    renderAll();
  }

  function updateVariant(skipResize) {
    state.variant = findVariant();
    state.spec = currentSpec();
    const colorIndex = optionNames().findIndex((name) => /color/i.test(name));
    const colorName = colorIndex >= 0 && state.variant ? variantOptions(state.variant)[colorIndex] : 'Bianco';
    state.productColor = colorForName(colorName);
    if (!skipResize) resizeCanvas(false); else resizeCanvas(false, true);
    $('tpv8-product-title').textContent = product().title;
    $('tpv8-product-detail').textContent = `${state.spec.wCm.toString().replace('.', ',')} × ${state.spec.hCm.toString().replace('.', ',')} cm${state.spec.detail ? ` · ${state.spec.detail}` : ''}`;
    $('tpv8-price').innerHTML = variantPriceMarkup(state.variant);
    $('tpv8-availability').textContent = state.variant && state.variant.available !== false ? 'Disponibile' : 'Non disponibile';
    $('tpv8-availability').classList.toggle('is-error', !state.variant || state.variant.available === false);
    $('tpv8-product-image').src = featuredImage();
    const variantDisplayTitle = state.productKey === 'puzzle' && state.spec && state.spec.label ? state.spec.label : (state.variant ? state.variant.title : '');
    $('tpv8-product-image').alt = state.variant && state.variant.title !== 'Default Title' ? `${product().title} - ${variantDisplayTitle}` : product().title;
    syncTshirtPreview();
    const printDpi = outputDpi();
    $('tpv8-print-size').textContent = `${state.spec.wCm.toString().replace('.', ',')} × ${state.spec.hCm.toString().replace('.', ',')} cm · ${printDpi} DPI`;
    root.querySelectorAll('.tpv8-summary-row').forEach((row) => {
      if (!/File di stampa/i.test(row.querySelector('span')?.textContent || '')) return;
      const value = row.querySelector('strong');
      if (value) value.textContent = `${printDpi} DPI`;
    });
    root.style.setProperty('--tpv8-product-color', '#ffffff');
    root.style.setProperty('--tpv8-variant-color', state.productColor);
    document.title = `${product().title} | Tela Personalizzata`;
    evaluateQuality();
  }

  function resizeCanvas(preserve = false, first = false) {
    const oldW = canvas.width || 1200;
    const oldH = canvas.height || 800;
    const ratio = state.spec.wCm / state.spec.hCm;
    const tshirtCssWidth = innerWidth <= 860 ? 155 : 170;
    const tshirtCssLongSide = tshirtCssWidth * 7 / 5;
    const previewScale = Math.min(Number(globalThis.devicePixelRatio) || 1, 2) * 1.3;
    const max = isTshirt() ? Math.max(560, Math.min(720, Math.round(tshirtCssLongSide * previewScale))) : 1200;
    const newW = ratio >= 1 ? max : Math.round(max * ratio);
    const newH = ratio >= 1 ? Math.round(max / ratio) : max;
    if (preserve && state.elements.length && !first) {
      const sx = newW / oldW;
      const sy = newH / oldH;
      const uniform = Math.sqrt(sx * sy);
      state.elements.forEach((item) => {
        const cx = (item.x + (item.w || 0) / 2) / oldW;
        const cy = (item.y + (item.h || 0) / 2) / oldH;
        if (item.type === 'image') {
          item.w *= uniform;
          item.h *= uniform;
          item.x = cx * newW - item.w / 2;
          item.y = cy * newH - item.h / 2;
        } else {
          item.x = (item.x / oldW) * newW;
          item.y = (item.y / oldH) * newH;
          item.size *= uniform;
        }
      });
    }
    canvas.width = newW;
    canvas.height = newH;
    $('tpv8-print-area').style.aspectRatio = `${state.spec.wCm} / ${state.spec.hCm}`;
    $('tpv8-safe-guide').style.inset = `${Math.round((state.spec.safeY || .04) * 100)}% ${Math.round((state.spec.safeX || .04) * 100)}%`;
    scheduleShellFit();
  }

  function releaseImageUrls() {
    state.elements.filter((item) => item.type === 'image' && item.objectUrl).forEach((item) => URL.revokeObjectURL(item.objectUrl));
  }

  function selected() {
    return state.elements.find((item) => item.id === state.selectedId) || null;
  }

  function coverScale(image) { return Math.max(canvas.width / image.naturalWidth, canvas.height / image.naturalHeight); }
  function containScale(image) { return Math.min(canvas.width / image.naturalWidth, canvas.height / image.naturalHeight); }

  function placeImage(image, file, mode = 'cover') {
    const firstImage = !state.elements.some((element) => element.type === 'image');
    remember();
    if (state.productKey === 'puzzle' && firstImage) {
      state.spec = currentSpec({ naturalW: image.naturalWidth, naturalH: image.naturalHeight });
      resizeCanvas(true);
    }
    const scale = mode === 'contain' ? containScale(image) : coverScale(image);
    const w = image.naturalWidth * scale;
    const h = image.naturalHeight * scale;
    const item = { id: uid(), type: 'image', name: file.name, x: (canvas.width - w) / 2, y: (canvas.height - h) / 2, w, h, rotation: 0, image, file, naturalW: image.naturalWidth, naturalH: image.naturalHeight, objectUrl: image.src, upload: null };
    state.elements.push(item);
    state.selectedId = item.id;
    if (state.productKey === 'puzzle' && firstImage) updateVariant(true);
    renderAll();
    if (firstImage && matchMedia('(max-width: 860px)').matches) {
      requestAnimationFrame(() => root.querySelector('.tpv8-editor-card')?.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }));
    }
  }

  async function loadImageFile(file) {
    if (!file) return;
    if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) return showError('Sono accettate immagini JPG, PNG o WEBP.');
    if (file.size > MAX_FILE_BYTES) return showError('Il file supera il limite di 20 MB.');
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.onload = () => {
      if (image.naturalWidth * image.naturalHeight > MAX_SOURCE_PIXELS) {
        URL.revokeObjectURL(url);
        showError('La fotografia è troppo grande da elaborare. Ridimensionala sotto 100 megapixel.');
        return;
      }
      placeImage(image, file, 'cover');
      $('tpv8-file-info').textContent = `${file.name} · ${(file.size / 1024 / 1024).toFixed(1).replace('.', ',')} MB · ${image.naturalWidth} × ${image.naturalHeight} px`;
    };
    image.onerror = () => { URL.revokeObjectURL(url); showError('La fotografia non può essere letta. Prova con un altro file.'); };
    image.src = url;
  }

  function selectedImage() {
    const item = selected();
    return item && item.type === 'image' ? item : state.elements.find((element) => element.type === 'image') || null;
  }

  function setImageMode(mode) {
    const item = selectedImage();
    if (!item) return;
    remember();
    const scale = mode === 'contain' ? containScale(item.image) : coverScale(item.image);
    item.w = item.naturalW * scale;
    item.h = item.naturalH * scale;
    item.x = (canvas.width - item.w) / 2;
    item.y = (canvas.height - item.h) / 2;
    renderAll();
  }

  function resizeSelected(factor, type = '') {
    const item = type === 'image' ? selectedImage() : selected();
    if (!item) return;
    remember();
    if (item.type === 'image') {
      const cx = item.x + item.w / 2;
      const cy = item.y + item.h / 2;
      item.w *= factor;
      item.h *= factor;
      item.x = cx - item.w / 2;
      item.y = cy - item.h / 2;
    } else {
      item.size = Math.max(12, Math.min(500, item.size * factor));
      renderAll();
      clampTextToCanvas(item);
    }
    renderAll();
  }

  function addText() {
    const text = $('tpv8-text').value.trim();
    if (!text) return showError('Scrivi prima il testo da aggiungere.');
    remember();
    const item = { id: uid(), type: 'text', name: text, text, x: canvas.width / 2, y: canvas.height * .38, w: 0, h: 0, font: $('tpv8-font-value').value || 'Arial', size: Number($('tpv8-font-size').value) || 72, color: $('tpv8-text-color').value, bold: false, italic: false, align: 'center', rotation: 0 };
    state.elements.push(item);
    state.selectedId = item.id;
    renderAll();
  }

  function drawElement(target, item, selectedState, sx = 1, sy = sx) {
    target.save();
    if (item.type === 'image') {
      target.translate((item.x + item.w / 2) * sx, (item.y + item.h / 2) * sy);
      target.rotate(item.rotation || 0);
      target.drawImage(item.image, -item.w * sx / 2, -item.h * sy / 2, item.w * sx, item.h * sy);
      if (selectedState) drawSelection(target, -item.w / 2, -item.h / 2, item.w, item.h);
    } else {
      target.translate(item.x * sx, item.y * sy);
      target.rotate(item.rotation || 0);
      target.fillStyle = item.color;
      target.textAlign = item.align;
      target.textBaseline = 'top';
      target.font = `${item.italic ? 'italic ' : ''}${item.bold ? '700 ' : ''}${item.size * sy}px "${item.font}"`;
      const lines = item.text.split('\n');
      let maxW = 0;
      lines.forEach((line, index) => {
        target.fillText(line, 0, index * item.size * 1.18 * sy);
        maxW = Math.max(maxW, target.measureText(line).width / sx);
      });
      item.w = maxW;
      item.h = lines.length * item.size * 1.18;
      if (selectedState) {
        const ox = item.align === 'center' ? -item.w / 2 : item.align === 'right' ? -item.w : 0;
        drawSelection(target, ox, -4, item.w, item.h + 8);
      }
    }
    target.restore();
  }

  function drawSelection(target, x, y, w, h) {
    target.strokeStyle = '#d8a329';
    target.lineWidth = Math.max(3, canvas.width / 420);
    target.strokeRect(x, y, w, h);
    const handle = Math.max(28, canvas.width / 46);
    target.fillStyle = '#fff';
    [[x, y], [x + w, y], [x, y + h], [x + w, y + h]].forEach(([px, py]) => {
      target.fillRect(px - handle / 2, py - handle / 2, handle, handle);
      target.strokeRect(px - handle / 2, py - handle / 2, handle, handle);
    });
  }

  function renderCanvas(target = ctx, withSelection = true, background = 'preview') {
    target.clearRect(0, 0, target.canvas.width, target.canvas.height);
    const transparentShirtPreview = background === 'preview' && isTshirt() && target.canvas === canvas;
    if (!transparentShirtPreview && (background === 'preview' || background === 'white')) {
      target.fillStyle = background === 'preview' ? (state.spec.editorBackground || '#ffffff') : '#ffffff';
      target.fillRect(0, 0, target.canvas.width, target.canvas.height);
    }
    state.elements.forEach((item) => drawElement(target, item, withSelection && item.id === state.selectedId));
  }

  function renderLayers() {
    const box = $('tpv8-layers');
    box.innerHTML = '';
    if (state.elements.length) {
      const select = document.createElement('select');
      select.className = 'tpv8-layer-select';
      select.setAttribute('aria-label', 'Elemento selezionato');
      [...state.elements].reverse().forEach((item) => {
        const option = document.createElement('option');
        option.value = item.id;
        option.textContent = `${item.type === 'image' ? 'Foto' : 'Testo'} · ${item.name || 'Elemento'}`;
        select.appendChild(option);
      });
      select.value = state.selectedId || state.elements[state.elements.length - 1].id;
      if (!state.selectedId) state.selectedId = select.value;
      select.addEventListener('change', () => { state.selectedId = select.value; renderAll(); });
      box.appendChild(select);
    }
    const selectedIndex = state.elements.findIndex((item) => item.id === state.selectedId);
    $('tpv8-layer-up-selected').disabled = selectedIndex < 0 || selectedIndex >= state.elements.length - 1;
    $('tpv8-delete').disabled = selectedIndex < 0;
  }

  function deleteElement(id = state.selectedId) {
    if (!id) return;
    remember();
    const removed = state.elements.find((item) => item.id === id);
    if (removed && removed.objectUrl) URL.revokeObjectURL(removed.objectUrl);
    state.elements = state.elements.filter((item) => item.id !== id);
    state.selectedId = null;
    renderAll();
  }

  function moveLayerUp(id) {
    const index = state.elements.findIndex((item) => item.id === id);
    if (index < 0 || index >= state.elements.length - 1) return;
    remember();
    [state.elements[index], state.elements[index + 1]] = [state.elements[index + 1], state.elements[index]];
    renderAll();
  }

  function syncJourneyState() {
    const hasImage = state.elements.some((element) => element.type === 'image');
    const journey = {
      variant: root.querySelector('[data-tpv8-journey="variant"]'),
      photo: root.querySelector('[data-tpv8-journey="photo"]'),
      review: root.querySelector('[data-tpv8-journey="review"]')
    };
    Object.values(journey).forEach((step) => {
      if (!step) return;
      step.classList.remove('is-current', 'is-complete');
      step.removeAttribute('aria-current');
    });
    if (journey.variant) journey.variant.classList.add('is-complete');
    const photoNote = journey.photo?.querySelector('small');
    if (photoNote) photoNote.textContent = hasImage ? 'Foto caricata' : 'La tua foto';
    if (hasImage) {
      journey.photo?.classList.add('is-complete');
      journey.review?.classList.add('is-current');
      journey.review?.setAttribute('aria-current', 'step');
    } else {
      journey.photo?.classList.add('is-current');
      journey.photo?.setAttribute('aria-current', 'step');
    }
    const uploadSuccess = $('tpv8-upload-success');
    if (uploadSuccess) uploadSuccess.hidden = !hasImage;
    const uploadLabel = $('tpv8-upload-trigger')?.querySelector('strong');
    if (uploadLabel) uploadLabel.textContent = hasImage ? 'Sostituisci la foto' : 'Carica una foto';
    $('tpv8-upload-trigger')?.classList.toggle('is-replace', hasImage);
    const visiblePrice = $('tpv8-price')?.textContent || '—';
    const mobilePrice = $('tpv8-mobile-price');
    if (mobilePrice) mobilePrice.textContent = visiblePrice;
    const cartButton = $('tpv8-cart');
    if (cartButton) cartButton.textContent = hasImage ? `Aggiungi al carrello · ${visiblePrice}` : 'Salva e aggiungi al carrello';
    const next = $('tpv8-next-action');
    if (next) next.textContent = hasImage
      ? 'Ultimo passo: controlla anteprima, quantità e prezzo.'
      : 'Prossimo passo: carica una foto.';
    if (!hasImage) {
      root.classList.remove('tpv8-text-open');
      const textTools = $('tpv8-text-tools');
      const textToggle = $('tpv8-text-toggle');
      if (textTools) textTools.hidden = true;
      if (textToggle) textToggle.setAttribute('aria-expanded', 'false');
    }
  }

  function syncControls() {
    const item = selected();
    $('tpv8-image-tools').hidden = !state.elements.some((element) => element.type === 'image');
    $('tpv8-text-tools').classList.toggle('is-editing', !!item && item.type === 'text');
    if (item && item.type === 'text') {
      root.classList.add('tpv8-text-open');
      $('tpv8-text-tools').hidden = false;
      $('tpv8-text-toggle').setAttribute('aria-expanded', 'true');
      $('tpv8-text').value = item.text;
      $('tpv8-font-size').value = Math.round(item.size);
      $('tpv8-text-color').value = item.color;
      selectFont(item.font, false);
      $('tpv8-bold').classList.toggle('is-active', item.bold);
      $('tpv8-italic').classList.toggle('is-active', item.italic);
    }
  }

  function renderAll(preservePuzzle = true) {
    syncPuzzleOrientation(preservePuzzle);
    renderCanvas();
    renderLayers();
    syncControls();
    evaluateQuality();
    $('tpv8-element-count').textContent = String(state.elements.length);
    $('tpv8-empty-layers').hidden = state.elements.length > 0;
    root.classList.toggle('tpv8-has-image', state.elements.some((item) => item.type === 'image'));
    root.classList.toggle('tpv8-has-text', state.elements.some((item) => item.type === 'text'));
    syncJourneyState();
    scheduleShellFit();
  }

  function effectiveDpi(item) {
    if (item.type !== 'image') return Infinity;
    return photoRules.placedDpi({
      naturalWidthPx: item.naturalW,
      naturalHeightPx: item.naturalH,
      printWidthCm: state.spec.wCm,
      printHeightCm: state.spec.hCm,
      placedWidthRatio: item.w / canvas.width,
      placedHeightRatio: item.h / canvas.height
    });
  }

  function evaluateQuality() {
    const images = state.elements.filter((item) => item.type === 'image');
    const label = $('tpv8-quality');
    if (!images.length) {
      label.textContent = 'Nessuna foto';
      label.className = 'tpv8-quality';
      syncQualityWarning(false);
      return;
    }
    const dpi = Math.min(...images.map(effectiveDpi));
    const quality = photoRules.classifyDpi(dpi);
    label.textContent = `${quality.label} · ${quality.dpi} DPI effettivi`;
    label.className = `tpv8-quality is-${quality.code}`;
    syncQualityWarning(dpi < 120);
  }

  function point(event) {
    const rect = canvas.getBoundingClientRect();
    return { x: (event.clientX - rect.left) * canvas.width / rect.width, y: (event.clientY - rect.top) * canvas.height / rect.height };
  }

  function textBounds(item) {
    const x = item.align === 'center' ? item.x - item.w / 2 : item.align === 'right' ? item.x - item.w : item.x;
    return { x, y: item.y, w: item.w, h: item.h };
  }

  function bounds(item) { return item.type === 'image' ? { x: item.x, y: item.y, w: item.w, h: item.h } : textBounds(item); }
  function clampTextToCanvas(item) {
    if (!item || item.type !== 'text') return;
    const b = bounds(item);
    if (![b.x, b.y, b.w, b.h].every(Number.isFinite)) return;
    let dx = 0;
    let dy = 0;
    if (b.w <= canvas.width) {
      if (b.x < 0) dx = -b.x;
      else if (b.x + b.w > canvas.width) dx = canvas.width - b.x - b.w;
    } else dx = canvas.width / 2 - b.x - b.w / 2;
    if (b.h <= canvas.height) {
      if (b.y < 0) dy = -b.y;
      else if (b.y + b.h > canvas.height) dy = canvas.height - b.y - b.h;
    } else dy = canvas.height / 2 - b.y - b.h / 2;
    item.x += dx;
    item.y += dy;
  }
  function hit(item, p) { const b = bounds(item); return p.x >= b.x && p.x <= b.x + b.w && p.y >= b.y && p.y <= b.y + b.h; }
  function handleHit(item, p) {
    const b = bounds(item);
    const radius = Math.max(40, canvas.width / 26);
    return [[b.x, b.y], [b.x + b.w, b.y], [b.x, b.y + b.h], [b.x + b.w, b.y + b.h]].some(([x, y]) => Math.abs(p.x - x) <= radius && Math.abs(p.y - y) <= radius);
  }

  canvas.addEventListener('pointerdown', (event) => {
    if (state.busy) return;
    const p = point(event);
    const current = selected();
    remember();
    if (current && handleHit(current, p)) {
      const b = bounds(current);
      const cx = b.x + b.w / 2;
      const cy = b.y + b.h / 2;
      state.dragging = { id: current.id, mode: 'resize', cx, cy, startW: current.w, startH: current.h, startSize: current.size, startDist: Math.max(10, Math.hypot(p.x - cx, p.y - cy)) };
    } else {
      const item = [...state.elements].reverse().find((candidate) => hit(candidate, p));
      if (!item) { state.history.pop(); state.selectedId = null; renderAll(); return; }
      state.selectedId = item.id;
      state.dragging = { id: item.id, mode: 'move', dx: p.x - item.x, dy: p.y - item.y };
    }
    canvas.setPointerCapture(event.pointerId);
    renderAll();
  });

  function scheduleDragRender() {
    if (dragRenderFrame) return;
    dragRenderFrame = requestAnimationFrame(() => {
      dragRenderFrame = 0;
      renderCanvas();
      evaluateQuality();
    });
  }

  canvas.addEventListener('pointermove', (event) => {
    if (!state.dragging) return;
    const item = state.elements.find((candidate) => candidate.id === state.dragging.id);
    if (!item) return;
    const p = point(event);
    if (state.dragging.mode === 'move') {
      item.x = p.x - state.dragging.dx;
      item.y = p.y - state.dragging.dy;
    } else {
      const factor = Math.max(.08, Math.hypot(p.x - state.dragging.cx, p.y - state.dragging.cy) / state.dragging.startDist);
      if (item.type === 'image') {
        item.w = state.dragging.startW * factor;
        item.h = state.dragging.startH * factor;
        item.x = state.dragging.cx - item.w / 2;
        item.y = state.dragging.cy - item.h / 2;
      } else item.size = Math.max(12, Math.min(500, state.dragging.startSize * factor));
    }
    clampTextToCanvas(item);
    state.dirty = true;
    scheduleDragRender();
  });
  ['pointerup', 'pointercancel'].forEach((name) => canvas.addEventListener(name, () => {
    if (dragRenderFrame) cancelAnimationFrame(dragRenderFrame);
    dragRenderFrame = 0;
    const draggedItem = state.elements.find((candidate) => candidate.id === state.dragging?.id);
    state.dragging = null;
    renderAll();
    clampTextToCanvas(draggedItem);
    renderAll();
  }));

  function ensureFontStyles(font = '') {
    if (!fontStylesPromise) {
      fontStylesPromise = new Promise((resolve) => {
        const existing = $('tpv8-font-styles');
        if (existing) { resolve(); return; }
        const link = document.createElement('link');
        link.id = 'tpv8-font-styles';
        link.rel = 'stylesheet';
        link.href = FONT_STYLESHEET_URL;
        link.onload = resolve;
        link.onerror = resolve;
        document.head.appendChild(link);
      });
    }
    return fontStylesPromise.then(() => {
      if (!font || SYSTEM_FONTS.has(font) || !document.fonts) return;
      return document.fonts.load('16px "' + font.replace(/"/g, '') + '"').catch(() => undefined);
    });
  }

  function buildFontPicker() {
    if (fontPickerBuilt) return;
    fontPickerBuilt = true;
    const menu = $('tpv8-font-menu');
    menu.innerHTML = '';
    FONT_GROUPS.forEach((group) => {
      const heading = document.createElement('div');
      heading.className = 'tpv8-font-group';
      heading.textContent = group.label;
      menu.appendChild(heading);
      group.fonts.forEach((font) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'tpv8-font-option';
        button.dataset.font = font;
        button.setAttribute('role', 'option');
        const sample = document.createElement('span');
        sample.className = 'tpv8-font-sample';
        sample.style.fontFamily = font;
        sample.textContent = 'Aa Testo';
        const name = document.createElement('span');
        name.textContent = font;
        button.append(sample, name);
        button.addEventListener('click', () => selectFont(font, true));
        menu.appendChild(button);
      });
    });
    ensureFontStyles();
    selectFont($('tpv8-font-value').value || 'Arial', false);
  }

  function selectFont(font, close = true) {
    $('tpv8-font-value').value = font;
    $('tpv8-font-name').textContent = font;
    $('tpv8-font-preview').textContent = 'Aa';
    $('tpv8-font-preview').style.fontFamily = font;
    $('tpv8-font-menu').querySelectorAll('.tpv8-font-option').forEach((button) => {
      const active = button.dataset.font === font;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    const item = selected();
    const changed = item && item.type === 'text' && item.font !== font;
    if (changed) { remember(); item.font = font; renderAll(); }
    if (!SYSTEM_FONTS.has(font)) {
      ensureFontStyles(font).then(() => {
        const current = selected();
        if (current && current.type === 'text' && current.font === font) renderCanvas();
      });
    }
    if (close) closeFontMenu();
  }

  function closeFontMenu() {
    $('tpv8-font-menu').hidden = true;
    $('tpv8-font-button').setAttribute('aria-expanded', 'false');
  }

  function updateSelectedText() {
    const item = selected();
    if (!item || item.type !== 'text') return;
    remember();
    item.text = $('tpv8-text').value;
    item.name = item.text || 'Testo';
    item.size = Math.max(12, Math.min(500, Number($('tpv8-font-size').value) || 72));
    item.color = $('tpv8-text-color').value;
    renderAll();
    clampTextToCanvas(item);
    renderAll();
  }

  function showError(message) {
    const status = $('tpv8-status');
    status.textContent = message;
    status.className = 'tpv8-status is-error';
    delete status.dataset.tpv8QualityWarning;
    status.hidden = false;
    status.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function showSuccess(message) {
    const status = $('tpv8-status');
    status.textContent = message;
    status.className = 'tpv8-status is-success';
    delete status.dataset.tpv8QualityWarning;
    status.hidden = false;
  }

  function syncQualityWarning(hasLowQuality) {
    const status = $('tpv8-status');
    if (hasLowQuality) {
      status.textContent = 'Qualità bassa: la stampa potrebbe risultare meno nitida. Puoi cambiare foto oppure continuare.';
      status.className = 'tpv8-status is-warning';
      status.dataset.tpv8QualityWarning = 'true';
      status.hidden = false;
      return;
    }
    if (status.dataset.tpv8QualityWarning === 'true') {
      status.textContent = '';
      status.className = 'tpv8-status';
      delete status.dataset.tpv8QualityWarning;
      status.hidden = true;
    }
  }

  function setProgress(percent, title, detail = '') {
    const overlay = $('tpv8-progress');
    overlay.hidden = false;
    $('tpv8-progress-title').textContent = title;
    $('tpv8-progress-detail').textContent = detail;
    $('tpv8-progress-bar').style.width = `${Math.max(0, Math.min(100, percent))}%`;
    $('tpv8-progress-percent').textContent = `${Math.round(percent)}%`;
  }

  function hideProgress() { $('tpv8-progress').hidden = true; }
  const pauseFrame = () => new Promise((resolve) => requestAnimationFrame(() => setTimeout(resolve, 0)));

  function renderOutput(maxPreview = false) {
    const output = document.createElement('canvas');
    const printDpi = outputDpi();
    let width = cmToPx(state.spec.wCm, printDpi);
    let height = cmToPx(state.spec.hCm, printDpi);
    if (maxPreview) {
      const scale = Math.min(1, 1200 / Math.max(width, height));
      width = Math.max(1, Math.round(width * scale));
      height = Math.max(1, Math.round(height * scale));
    }
    output.width = width;
    output.height = height;
    const out = output.getContext('2d', { alpha: true });
    if (maxPreview) {
      out.fillStyle = state.spec.editorBackground || '#ffffff';
      out.fillRect(0, 0, width, height);
    } else if (state.spec.printBackground === 'white') {
      out.fillStyle = '#ffffff';
      out.fillRect(0, 0, width, height);
    } else out.clearRect(0, 0, width, height);
    const sx = width / canvas.width;
    const sy = height / canvas.height;
    state.elements.forEach((item) => drawElement(out, item, false, sx, sy));
    return output;
  }

  function toBlob(output, type, quality) {
    return new Promise((resolve, reject) => output.toBlob((blob) => blob ? resolve(blob) : reject(new Error('Il browser non ha potuto generare il file.')), type, quality));
  }

  function storageUrl(name, type) {
    const template = config.storage && config.storage.template;
    if (!template) throw new Error('Archivio file non configurato.');
    return template
      .replace('${shop}', encodeURIComponent(config.shop || ''))
      .replace('${name}', encodeURIComponent(name))
      .replace('${type}', encodeURIComponent(type))
      .replace('${public}', '1')
      .replace('${cb}', String(Math.floor(100000000000000000 + Math.random() * 900000000000000000)));
  }

  async function uploadAsset(blob, filename, meta) {
    const storageResponse = await fetch(storageUrl(filename, blob.type || 'application/octet-stream'));
    if (!storageResponse.ok) throw new Error(`Preparazione archivio fallita (${storageResponse.status}).`);
    const storage = await storageResponse.json();
    if (!storage.upload || !storage.path) throw new Error('Risposta archivio incompleta.');
    const put = await fetch(storage.upload, { method: 'PUT', headers: { 'Content-Type': blob.type || 'application/octet-stream' }, body: blob });
    if (!put.ok) throw new Error(`Caricamento file fallito (${put.status}).`);
    const payload = { name: filename, size: blob.size, mimeType: blob.type, meta: { ...meta, contentLength: blob.size }, url: storage.download, path: storage.path };
    const register = await fetch(config.storage.register, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    if (!register.ok) throw new Error(`Registrazione file fallita (${register.status}).`);
    const registered = await register.json().catch(() => ({}));
    return { path: registered.path || storage.path, url: registered.url || storage.download, name: filename, size: blob.size, mimeType: blob.type };
  }

  function serializeElements() {
    return state.elements.map((item) => item.type === 'image' ? {
      id: item.id, type: item.type, name: item.name, x: item.x / canvas.width, y: item.y / canvas.height,
      width: item.w / canvas.width, height: item.h / canvas.height, rotation: item.rotation || 0,
      source: item.upload ? { path: item.upload.path, url: item.upload.url, width: item.naturalW, height: item.naturalH } : null
    } : {
      id: item.id, type: item.type, text: item.text, x: item.x / canvas.width, y: item.y / canvas.height,
      font: item.font, size: item.size / canvas.height, color: item.color, bold: item.bold, italic: item.italic, align: item.align, rotation: item.rotation || 0
    });
  }

  async function prepareAndAddToCart() {
    if (state.busy) return;
    if (!state.variant || state.variant.available === false) return showError('La variante scelta non è disponibile.');
    if (!state.elements.length) return showError('Aggiungi almeno una fotografia o un testo.');
    if (config.mode === 'demo') {
      showSuccess('Modalità demo: editor e varianti funzionano. Il carrello sarà attivo nella pagina Shopify V8.');
      return;
    }
    const cartButton = $('tpv8-cart');
    let redirecting = false;
    state.busy = true;
    cartButton.disabled = true;
    cartButton.setAttribute('aria-busy', 'true');
    cartButton.textContent = 'Preparazione in corso…';
    updateUndoButtons();
    setProgress(1, 'Prepariamo la personalizzazione', 'Non chiudere questa pagina');
    try {
      const customizationId = `TPV8-${Date.now().toString(36).toUpperCase()}-${Math.random().toString(36).slice(2, 7).toUpperCase()}`;
      const baseMeta = { variant: 'tp-v8', customizationId, productId: Number(product().id), productHandle: product().handle, productTitle: product().title, productVariantId: Number(state.variant.id), version: VERSION };
      const images = state.elements.filter((item) => item.type === 'image');
      for (let index = 0; index < images.length; index += 1) {
        setProgress(5 + (index / Math.max(1, images.length)) * 25, 'Salviamo le fotografie originali', `${index + 1} di ${images.length}`);
        images[index].upload = await uploadAsset(images[index].file, `${customizationId}-originale-${index + 1}-${safeFilename(images[index].file.name)}`, { ...baseMeta, variant: 'original' });
      }
      const printDpi = outputDpi();
      setProgress(38, 'Prepariamo il file di stampa', `${state.spec.wCm} × ${state.spec.hCm} cm · ${printDpi} DPI`);
      await pauseFrame();
      const printCanvas = renderOutput(false);
      const printBlob = await toBlob(printCanvas, 'image/png');
      setProgress(58, 'Carichiamo il file di stampa', `${Math.round(printBlob.size / 1024 / 1024 * 10) / 10} MB`);
      const printAsset = await uploadAsset(printBlob, `${customizationId}-stampa-${state.spec.wCm}x${state.spec.hCm}cm-${printDpi}dpi.png`, { ...baseMeta, variant: `print-${printDpi}dpi`, widthPx: printCanvas.width, heightPx: printCanvas.height, dpi: printDpi });
      printCanvas.width = 1;
      printCanvas.height = 1;
      setProgress(70, 'Creiamo l’anteprima ordine');
      await pauseFrame();
      const previewCanvas = renderOutput(true);
      const previewBlob = await toBlob(previewCanvas, 'image/jpeg', .86);
      const previewAsset = await uploadAsset(previewBlob, `${customizationId}-anteprima.jpg`, { ...baseMeta, variant: 'preview' });
      previewCanvas.width = 1;
      previewCanvas.height = 1;
      const configuration = {
        schema: 'telapersonalizzata-configurator-v8', version: VERSION, customizationId, createdAt: new Date().toISOString(),
        shop: config.shop, product: { id: product().id, handle: product().handle, title: product().title },
        variant: { id: state.variant.id, title: state.variant.title, selections: state.selections, price: state.variant.price },
        quantity: Math.max(1, Number($('tpv8-quantity').value) || 1),
        print: { widthCm: state.spec.wCm, heightCm: state.spec.hCm, dpi: printDpi, background: state.spec.printBackground, file: printAsset },
        preview: previewAsset, elements: serializeElements()
      };
      const configBlob = new Blob([JSON.stringify(configuration, null, 2)], { type: 'application/json' });
      setProgress(84, 'Salviamo la configurazione');
      const configAsset = await uploadAsset(configBlob, `${customizationId}-configurazione.json`, { ...baseMeta, variant: 'configuration' });
      setProgress(92, 'Aggiungiamo il prodotto al carrello');
      const response = await fetch('/cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(state.variant.id), quantity: configuration.quantity, properties: {
          Personalizzazione: customizationId,
          '_tp_v8_version': VERSION,
          '_tp_configurazione': configAsset.url || configAsset.path,
          '_tp_file_stampa': printAsset.url || printAsset.path,
          '_tp_anteprima': previewAsset.url || previewAsset.path
        } }] })
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || error.message || `Carrello non disponibile (${response.status}).`);
      }
      setProgress(100, 'Personalizzazione aggiunta', 'Apriamo il carrello…');
      state.dirty = false;
      redirecting = true;
      setTimeout(() => location.assign('/cart'), 450);
    } catch (error) {
      console.error('TP V8 ordine', error);
      hideProgress();
      showError(`Non siamo riusciti a completare la personalizzazione: ${error.message}`);
    } finally {
      if (!redirecting) {
        state.busy = false;
        cartButton.disabled = false;
        cartButton.removeAttribute('aria-busy');
        syncJourneyState();
        updateUndoButtons();
      }
    }
  }

  function bindControls() {
    $('tpv8-product').addEventListener('change', (event) => selectProduct(event.target.value));
    $('tpv8-upload-trigger').addEventListener('click', () => $('tpv8-image-upload').click());
    $('tpv8-image-upload').addEventListener('change', (event) => { const file = event.target.files && event.target.files[0]; event.target.value = ''; loadImageFile(file); });
    $('tpv8-zoom-out').addEventListener('click', () => resizeSelected(.9, 'image'));
    $('tpv8-zoom-in').addEventListener('click', () => resizeSelected(1.1, 'image'));
    $('tpv8-fit').addEventListener('click', () => setImageMode('contain'));
    $('tpv8-fill').addEventListener('click', () => setImageMode('cover'));
    $('tpv8-center').addEventListener('click', () => {
      const item = selectedImage();
      if (!item) return;
      remember();
      if (item.type === 'image') { item.x = (canvas.width - item.w) / 2; item.y = (canvas.height - item.h) / 2; }
      else { item.x = canvas.width / 2; item.y = (canvas.height - item.h) / 2; item.align = 'center'; }
      renderAll();
    });
    $('tpv8-grid').addEventListener('click', () => { state.grid = !state.grid; $('tpv8-grid-overlay').hidden = !state.grid; $('tpv8-grid').classList.toggle('is-active', state.grid); $('tpv8-grid').setAttribute('aria-pressed', state.grid ? 'true' : 'false'); });
    $('tpv8-text-toggle').addEventListener('click', () => {
      const open = !root.classList.contains('tpv8-text-open');
      root.classList.toggle('tpv8-text-open', open);
      $('tpv8-text-tools').hidden = !open;
      $('tpv8-text-toggle').setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) $('tpv8-text').focus();
      scheduleShellFit();
    });
    $('tpv8-add-text').addEventListener('click', addText);
    $('tpv8-text-smaller').addEventListener('click', () => resizeSelected(.9));
    $('tpv8-text-larger').addEventListener('click', () => resizeSelected(1.1));
    $('tpv8-bold').addEventListener('click', () => { const item = selected(); if (item && item.type === 'text') { remember(); item.bold = !item.bold; renderAll(); } });
    $('tpv8-italic').addEventListener('click', () => { const item = selected(); if (item && item.type === 'text') { remember(); item.italic = !item.italic; renderAll(); } });
    [['tpv8-align-left', 'left'], ['tpv8-align-center', 'center'], ['tpv8-align-right', 'right']].forEach(([id, align]) => $(id).addEventListener('click', () => { const item = selected(); if (item && item.type === 'text') { remember(); item.align = align; renderAll(); } }));
    ['tpv8-text', 'tpv8-font-size', 'tpv8-text-color'].forEach((id) => $(id).addEventListener('change', updateSelectedText));
    $('tpv8-font-button').addEventListener('click', () => { buildFontPicker(); const menu = $('tpv8-font-menu'); menu.hidden = !menu.hidden; $('tpv8-font-button').setAttribute('aria-expanded', menu.hidden ? 'false' : 'true'); });
    document.addEventListener('pointerdown', (event) => { if (!$('tpv8-font-picker').contains(event.target)) closeFontMenu(); });
    $('tpv8-delete').addEventListener('click', () => deleteElement());
    $('tpv8-layer-up-selected').addEventListener('click', () => moveLayerUp(state.selectedId));
    $('tpv8-undo').addEventListener('click', undo);
    $('tpv8-redo').addEventListener('click', redo);
    $('tpv8-reset').addEventListener('click', () => { if (!state.elements.length || confirm('Vuoi cancellare tutta la personalizzazione?')) { remember(); releaseImageUrls(); state.elements = []; state.selectedId = null; $('tpv8-file-info').textContent = 'Nessuna foto caricata'; renderAll(); } });
    $('tpv8-cart').addEventListener('click', prepareAndAddToCart);
    canvas.addEventListener('keydown', (event) => {
      const item = selected();
      if (!item || state.busy) return;
      if (event.key === 'Delete' || event.key === 'Backspace') { event.preventDefault(); deleteElement(); return; }
      const delta = event.shiftKey ? 10 : 2;
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
        event.preventDefault();
        remember();
        if (event.key === 'ArrowLeft') item.x -= delta;
        if (event.key === 'ArrowRight') item.x += delta;
        if (event.key === 'ArrowUp') item.y -= delta;
        if (event.key === 'ArrowDown') item.y += delta;
        clampTextToCanvas(item);
        renderAll();
      }
    });
    addEventListener('beforeunload', (event) => { if (state.dirty && !state.busy) { event.preventDefault(); event.returnValue = ''; } });
    addEventListener('resize', scheduleShellFit, { passive: true });
    addEventListener('scroll', scheduleShellFit, { passive: true });
    if (globalThis.visualViewport) visualViewport.addEventListener('resize', scheduleShellFit, { passive: true });
    addEventListener('load', scheduleShellFit, { once: true });
  }

  selectFont('Arial', false);
  bindControls();
  showContinuousPanel();
  populateProductSelect();
  updateUndoButtons();
  scheduleShellFit();
  root.dataset.ready = 'true';
  globalThis.TelaPersonalizzataV8 = {
    version: VERSION,
    summary: () => ({ mode: config.mode || 'shopify', product: state.productKey, variantId: state.variant && state.variant.id, selections: { ...state.selections }, elements: state.elements.length, quality: $('tpv8-quality').textContent, variantColor: state.productColor, editorBackground: state.spec.editorBackground || '#ffffff', print: { ...state.spec } })
  };
})();

/* Task03 trial gift presentation: original engine and handlers retained. */
(() => {
  const root=document.getElementById('tp-v8-app'); if(!root)return;
  const supported=['tshirt','puzzle','mousepad'];
  const byId=id=>document.getElementById(id);
  const imageTools=byId('tpv8-image-tools');
  const toolsHome=imageTools?{parent:imageTools.parentNode,next:imageTools.nextSibling}:null;
  const text=(node,value)=>{if(node&&node.textContent!==value)node.textContent=value;};
  let pending=false;
  function sync(){
    const key=byId('tpv8-product')?.value;
    if(!supported.includes(key)){
      if(root.hasAttribute('data-tpv8-gift-ui')&&toolsHome&&imageTools.parentNode!==toolsHome.parent){toolsHome.parent.insertBefore(imageTools,toolsHome.next?.parentNode===toolsHome.parent?toolsHome.next:null);}
      root.removeAttribute('data-tpv8-gift-ui');byId('tpv8-gift-head')?.remove();return;
    }
    root.dataset.tpv8GiftUi=key;
    const stage=root.querySelector('.tpv8-canvas-stage');
    if(stage&&imageTools&&stage.nextElementSibling!==imageTools)stage.after(imageTools);
    let head=byId('tpv8-gift-head');
    if(!head){head=document.createElement('header');head.id='tpv8-gift-head';head.innerHTML='<div><small>TelaPersonalizzata</small><h1></h1></div><strong aria-label="Prezzo"></strong>';root.prepend(head);}
    text(head.querySelector('h1'),byId('tpv8-product-title')?.textContent||'Personalizza il tuo prodotto');
    const price=byId('tpv8-price');text(head.querySelector('strong'),(price?.querySelector('em')||price)?.textContent.trim()||'');
  }
  function schedule(){if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;sync();});}
  root.addEventListener('change',schedule);
  new MutationObserver(schedule).observe(root,{subtree:true,childList:true,attributes:true,attributeFilter:['class','hidden']});
  sync();
})();

/* TP mugs trial UI 2026-09-12: presentation only; V8 editing/export unchanged. */
(() => {
  'use strict';
  const root = document.getElementById('tp-v8-app');
  if (!root) return;
  const byId = id => document.getElementById(id);
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const imageTools = byId('tpv8-image-tools');
  const imageToolsHome = imageTools ? {parent: imageTools.parentNode, next: imageTools.nextSibling} : null;
  let active = 'photo';
  function syncMugs() {
    const key = byId('tpv8-product')?.value;
    const enabled = key === 'mug' || key === 'magic-mug';
    if (!enabled) {
      if (root.hasAttribute('data-tpv8-mugs') && imageToolsHome && imageTools.parentNode !== imageToolsHome.parent) {
        imageToolsHome.parent.insertBefore(imageTools, imageToolsHome.next?.parentNode === imageToolsHome.parent ? imageToolsHome.next : null);
      }
      root.removeAttribute('data-tpv8-mugs');
      root.removeAttribute('data-tpv8-mugs-panel');
      root.querySelectorAll('[data-tpv8-mugs-owned]').forEach(node => node.remove());
      active = 'photo';
      return;
    }
    root.dataset.tpv8Mugs = key;
    const stage = root.querySelector('.tpv8-canvas-stage');
    // Move the original buttons, preserving listeners and native hidden state.
    if (stage && imageTools && stage.nextElementSibling !== imageTools) stage.after(imageTools);
    let head = byId('tpv8-mugs-head');
    if (!head) {
      head = document.createElement('header');
      head.id = 'tpv8-mugs-head';
      head.setAttribute('data-tpv8-mugs-owned', '');
      head.innerHTML = '<div><small>TelaPersonalizzata</small><h1></h1></div><strong aria-label="Prezzo"></strong>';
      root.prepend(head);
    }
    setText(head.querySelector('h1'), key === 'mug' ? 'Personalizza la tua tazza' : 'Personalizza la tazza magica');
    const price = byId('tpv8-price');
    setText(head.querySelector('strong'), (price?.querySelector('em') || price)?.textContent.trim() || '');
    let tabs = byId('tpv8-mugs-tabs');
    if (!tabs) {
      tabs = document.createElement('div');
      tabs.id = 'tpv8-mugs-tabs';
      tabs.setAttribute('data-tpv8-mugs-owned', '');
      tabs.innerHTML = '<div role="tablist" aria-label="Personalizzazione"><button type="button" role="tab" data-mugs-tab="photo" aria-controls="tpv8-panel-photo">Foto</button><button type="button" role="tab" data-mugs-tab="text" aria-controls="tpv8-panel-text">Scritta facoltativa</button></div><p>Carica una foto per aggiungere una scritta.</p>';
      byId('tpv8-panel-photo')?.before(tabs);
      tabs.addEventListener('click', event => {
        const button = event.target.closest('[data-mugs-tab]');
        if (!button || button.disabled) return;
        active = button.dataset.mugsTab;
        if (active === 'text' && byId('tpv8-text-tools')?.hidden) byId('tpv8-text-toggle')?.click();
        syncMugs();
      });
    }
    const hasImage = root.classList.contains('tpv8-has-image');
    // The core price contains adjacent compare-at/discount/current spans.
    // Keep the offer in the summary and show only the payable price on the CTA.
    if (hasImage) {
      const currentPrice = (price?.querySelector('em') || price)?.textContent.trim();
      if (currentPrice) setText(byId('tpv8-cart'), 'Aggiungi al carrello · ' + currentPrice);
    }
    if (!hasImage) active = 'photo';
    root.dataset.tpv8MugsPanel = active;
    if (tabs.querySelector('p').hidden !== hasImage) tabs.querySelector('p').hidden = hasImage;
    tabs.querySelectorAll('[data-mugs-tab]').forEach(button => {
      button.disabled = button.dataset.mugsTab === 'text' && !hasImage;
      const selected = button.dataset.mugsTab === active;
      if (button.getAttribute('aria-selected') !== String(selected)) button.setAttribute('aria-selected', String(selected));
    });
    let note = byId('tpv8-mugs-note');
    if (!note) {
      note = document.createElement('p');
      note.id = 'tpv8-mugs-note';
      note.setAttribute('data-tpv8-mugs-owned', '');
      note.textContent = 'Anteprima panoramica · area attuale 20 × 9,7 cm';
      root.querySelector('.tpv8-canvas-stage')?.prepend(note);
    }
  }
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; syncMugs(); });
  };
  root.addEventListener('change', schedule);
  byId('tpv8-canvas')?.addEventListener('pointerup', () => {
    if (!root.hasAttribute('data-tpv8-mugs')) return;
    requestAnimationFrame(() => {
      if (byId('tpv8-text-tools')?.classList.contains('is-editing')) active = 'text';
      syncMugs();
    });
  });
  new MutationObserver(schedule).observe(root, {subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden']});
  syncMugs();
})();
